export default "__VITE_ASSET__0e9424b1__"